'use strict'
import urls from './Urls'
import axios from 'axios'

export const CHILD_API_ENDPOINTS = {
  ORG: 'org',
  ORG_SAVE: 'org/save',
  ORG_VALIDATE: 'org/validate',
  PERSONNEL: 'personnel',
  PERSONNEL_TITLES: 'personnel/titles',
  PERSONNEL_SAVE: 'personnel/save',
  PERSONNEL_VALIDATE: 'personnel/validate',

  COORDINATOR: 'coordinator',
  COORDINATOR_TITLES: 'coordinator/titles',
  COORDINATOR_SAVE: 'coordinator/save',
  COORDINATOR_VALIDATE: 'coordinator/validate',

  SPORT: 'sport',
  SPORT_SAVE: 'sport/save',
  SPORT_VALIDATE: 'sport/validate',
  LIST: 'list',
  ORG_VIEW: 'orgView',
  SPORT_VIEW: 'sportView',
  PERSONNEL_VIEW: 'personnelView',

  LOGO_VIEW: 'logoView',
  DETAIL: 'detail',
  APPROVE_ORG: 'approveOrg',
  APPROVE_SPORT: 'approveSport',
  APPROVE_PERSONNEL: 'approvePersonnel',
  APPROVE_COORDINATOR: 'approveCoordinator',
  DENY: 'deny',
  CANCEL: 'cancel',
  SAVE_FUTURE_ORG: 'saveFutureOrg',
  SAVE_FUTURE_SPORT: 'saveFutureSport',
  SAVE_FUTURE_PERSONNEL: 'saveFuturePersonnel',
  DUPLICATES: 'duplicates'
}

// Org Change Request URL
function getOrgApiEndPoint () {
  return urls.changeRequestApiController() + '/' + CHILD_API_ENDPOINTS.ORG
}

function getOrgSaveApiEndPoint () {
  return urls.changeRequestApiController() + '/' + CHILD_API_ENDPOINTS.ORG_SAVE
}

function getOrgValidateApiEndPoint () {
  return urls.changeRequestApiController() + '/' + CHILD_API_ENDPOINTS.ORG_VALIDATE
}

// Personnel Change Request URL
function getPersonnelApiEndPoint () {
  return urls.changeRequestApiController() + '/' + CHILD_API_ENDPOINTS.PERSONNEL
}

function getPersonnelSaveApiEndPoint () {
  return urls.changeRequestApiController() + '/' + CHILD_API_ENDPOINTS.PERSONNEL_SAVE
}

function getPersonnelValidateApiEndPoint () {
  return urls.changeRequestApiController() + '/' + CHILD_API_ENDPOINTS.PERSONNEL_VALIDATE
}

function getPersonnelTitlesApiEndPoint () {
  return urls.changeRequestApiController() + '/' + CHILD_API_ENDPOINTS.PERSONNEL_TITLES
}
// Coordinator Change Request URL
function getCoordinatorApiEndPoint () {
  return urls.changeRequestApiController() + '/' + CHILD_API_ENDPOINTS.COORDINATOR
}

function getCoordinatorSaveApiEndPoint () {
  return urls.changeRequestApiController() + '/' + CHILD_API_ENDPOINTS.COORDINATOR_SAVE
}

function getCoordinatorTitlesApiEndPoint () {
  return urls.changeRequestApiController() + '/' + CHILD_API_ENDPOINTS.COORDINATOR_TITLES
}

// Sport Change Request URL
function getSportApiEndPoint () {
  return urls.changeRequestApiController() + '/' + CHILD_API_ENDPOINTS.SPORT
}

function getSportSaveApiEndPoint () {
  return urls.changeRequestApiController() + '/' + CHILD_API_ENDPOINTS.SPORT_SAVE
}

function getSportValidateApiEndPoint () {
  return urls.changeRequestApiController() + '/' + CHILD_API_ENDPOINTS.SPORT_VALIDATE
}

function getListApiEndPoint (status, type) {
  let paramStr = '?status=' + status
  let currentUrl = window.location.href

  if (type) {
    paramStr += '&type=' + type
  }
  return (currentUrl.indexOf('admin') > 0 ? urls.changeRequestAdminApiController() : urls.changeRequestApiController()) + '/' + CHILD_API_ENDPOINTS.LIST + paramStr
}

function getAdminListEndPoint () {
  return urls.changeRequestAdminController()
}

function getListEndPoint () {
  return urls.changeRequestController()
}

function getPersonnelEditChangeRequestEndPoint (orgId, personId) {
  return urls.changeRequestController() + '/' + CHILD_API_ENDPOINTS.PERSONNEL + '?type=false&action=edit&orgId=' + orgId + '&personId=' + personId
}

// URL for existing change request view page
function getChangeRequestViewEndPoint (id, type) {
  let paramStr = '?id=' + id
  let view = ''
  let currentUrl = window.location.href

  if (type === 'O') {
    view = CHILD_API_ENDPOINTS.ORG_VIEW
  } else if (type === 'S') {
    view = CHILD_API_ENDPOINTS.SPORT_VIEW
  } else if (type === 'P') {
    view = CHILD_API_ENDPOINTS.PERSONNEL_VIEW
  } else if (type === 'C') {
    view = CHILD_API_ENDPOINTS.COORDINATOR_VIEW
  }

  return (currentUrl.indexOf('admin') > 0 ? urls.changeRequestAdminController() : urls.changeRequestController()) + '/' + view + paramStr
}

function getLogoViewEndPoint (id, originalFile) {
  return urls.changeRequestController() + '/' + CHILD_API_ENDPOINTS.LOGO_VIEW + '?id=' + id + (originalFile ? '&orig=true' : '')
}

function getChangeRequestDetailApiEndPoint () {
  return urls.changeRequestApiController() + '/' + CHILD_API_ENDPOINTS.DETAIL
}

function getPersonnelDuplicatesApiEndPoint () {
  return urls.changeRequestAdminApiController() + '/' + CHILD_API_ENDPOINTS.DUPLICATES
}

// Initiate Organizational Change Request
function initiateChangeRequestOrg (orgId) {
  return axios.get(getOrgApiEndPoint(), {
    params: {
      'orgId': orgId
    }
  })
}

// Initiate Personnel Change Request
function initiateChangeRequestPersonnel (params) {
  return axios.get(getPersonnelApiEndPoint(), {
    params: params
  })
}

// Initiate Personnel Change Request
function initiateChangeRequestSport (params) {
  return axios.get(getSportApiEndPoint(), {
    params: params
  })
}

// Initiate Personnel Change Request
function initiateChangeRequestCoordinator (params) {
  return axios.get(getCoordinatorApiEndPoint(), {
    params: params
  })
}

function getPersonnelTitles (orgId, personId) {
  return axios.get(getPersonnelTitlesApiEndPoint(), {
    params: {
      'orgId': orgId,
      'personId': personId
    }
  })
}

function getCoordinatorTitles (orgId, personId) {
  return axios.get(getCoordinatorTitlesApiEndPoint(), {
    params: {
      'orgId': orgId,
      'personId': personId
    }
  })
}
// Get existing change request details
function getExistingChangeRequest (id) {
  return axios.get(getChangeRequestDetailApiEndPoint(), {
    params: {
      'id': id
    }
  })
}

// Get existing change request details
function getPersonnelDuplicates (email) {
  return axios.get(getPersonnelDuplicatesApiEndPoint(), {
    params: {
      'email': email
    }
  })
}

function saveOrgChangeRequest (data) {
  return axios.post(getOrgSaveApiEndPoint(), data)
}

function validateOrgChangeRequest (data) {
  return axios.post(getOrgValidateApiEndPoint(), data)
}

function savePersonnelChangeRequest (data) {
  return axios.post(getPersonnelSaveApiEndPoint(), data)
}

function validatePersonnelChangeRequest (data) {
  return axios.post(getPersonnelValidateApiEndPoint(), data)
}

function saveCoordinatorChangeRequest (data) {
  return axios.post(getCoordinatorSaveApiEndPoint(), data)
}

function saveSportChangeRequest (data) {
  return axios.post(getSportSaveApiEndPoint(), data)
}

function validateSportChangeRequest (data) {
  return axios.post(getSportValidateApiEndPoint(), data)
}

function validateCoordinatorChangeRequest (data) {
  return axios.post(getSportValidateApiEndPoint(), data)
}
function approveChangeRequest (data, requestType) {
  let approveUrl = ''
  if (requestType === 'O') {
    approveUrl = CHILD_API_ENDPOINTS.APPROVE_ORG
  } else if (requestType === 'S') {
    approveUrl = CHILD_API_ENDPOINTS.APPROVE_SPORT
  } else if (requestType === 'P') {
    approveUrl = CHILD_API_ENDPOINTS.APPROVE_PERSONNEL
  } else if (requestType === 'C') {
    approveUrl = CHILD_API_ENDPOINTS.APPROVE_COORDINATOR
  }

  return axios.post(urls.changeRequestAdminApiController() + '/' + approveUrl, data)
}

function denyChangeRequest (data) {
  return axios.post(urls.changeRequestAdminApiController() + '/' + CHILD_API_ENDPOINTS.DENY, data)
}

function cancelChangeRequest (data) {
  return axios.post(urls.changeRequestApiController() + '/' + CHILD_API_ENDPOINTS.CANCEL, data)
}

function saveFutureChangeRequest (data, requestTypeCode) {
  let saveFutureUrl = ''
  if (requestTypeCode === 'O') {
    saveFutureUrl = CHILD_API_ENDPOINTS.SAVE_FUTURE_ORG
  } else if (requestTypeCode === 'S') {
    saveFutureUrl = CHILD_API_ENDPOINTS.SAVE_FUTURE_SPORT
  } else if (requestTypeCode === 'P') {
    saveFutureUrl = CHILD_API_ENDPOINTS.SAVE_FUTURE_PERSONNEL
  }
  return axios.post(urls.changeRequestAdminApiController() + '/' + saveFutureUrl, data)
}

export default {
  initiateChangeRequestOrg: initiateChangeRequestOrg,
  initiateChangeRequestPersonnel: initiateChangeRequestPersonnel,
  initiateChangeRequestSport: initiateChangeRequestSport,
  saveOrgChangeRequest: saveOrgChangeRequest,

  validateOrgChangeRequest: validateOrgChangeRequest,
  savePersonnelChangeRequest: savePersonnelChangeRequest,
  validatePersonnelChangeRequest: validatePersonnelChangeRequest,

  saveCoordinatorChangeRequest: saveCoordinatorChangeRequest,
  validateCoordinatorChangeRequest: validateCoordinatorChangeRequest,
  initiateChangeRequestCoordinator: initiateChangeRequestCoordinator,

  saveSportChangeRequest: saveSportChangeRequest,
  validateSportChangeRequest: validateSportChangeRequest,
  getListApiEndPoint: getListApiEndPoint,
  getAdminListEndPoint: getAdminListEndPoint,
  getChangeRequestViewEndPoint: getChangeRequestViewEndPoint,
  getExistingChangeRequest: getExistingChangeRequest,
  approveChangeRequest: approveChangeRequest,
  denyChangeRequest: denyChangeRequest,
  cancelChangeRequest: cancelChangeRequest,
  getLogoViewEndPoint: getLogoViewEndPoint,
  getListEndPoint: getListEndPoint,

  getPersonnelTitles: getPersonnelTitles,
  getCoordinatorTitles: getCoordinatorTitles,

  saveFutureChangeRequest: saveFutureChangeRequest,
  getPersonnelEditChangeRequestEndPoint: getPersonnelEditChangeRequestEndPoint,
  getPersonnelDuplicates: getPersonnelDuplicates
}
